module.exports = (__webpack_require__(9366))(24);